export enum Routes {
  MaterialsRouter = '/materials/*',
  ItemsPage = 'items',
  TrackingPage = 'tracking',
  TransferOrdersPage = 'transfer-orders',
}
